// The feature panels compare a place against its State row, which the server builds as a
// population and area weighted mean. On a skewed indicator that sits well above the typical
// place, so a value below it can still rank above the 50th percentile, which is what made the
// diesel PM percentile look wrong. These read the real median, fetched per indicator, geography
// and period, against the same population the percentile is ranked within.

// Indicators with one date arrive without a year, so they need a key of their own.
export const medianYearKey = year => (year === undefined || year === null ? 'latest' : `${year}`);

// 'pending' while the request is in flight, null when the indicator has no median to give
export const readMedian = (medians, geography, indicator, year) => {
  const byIndicator = medians && medians[geography] && medians[geography][indicator];
  return byIndicator ? byIndicator[medianYearKey(year)] : undefined;
};

export const hasMedian = entry => typeof entry === 'number';

// undefined means nobody has asked yet, which is the only state worth a request
export const needsMedian = entry => entry === undefined;
